<template>
  <div class="message-input-component" >
    <div
      v-click-outside="hideQuickReply"
      class="message-input-wrapper"
      data-outside-click="input-wrapper"
      :class="{
        focus: inputWraperFocused,
        'add-shadow': focusShadow && inputWraperFocused,
        disabled,
      }">
      <div
        v-if="replyTo"
        class="reply-message flex center-all"
        :class="{ 'recording-running': recordingInProgress }">
        <div class="greedy">
          <div
            class="reply-message-origin" >
            <div class="header flex flex-align-center">
              <SBIcon
                class="mr-1"
                :icon="SBIconList.REPLY_SINGLE"
                :color="SBColors.blackUltralight"
                :size="9" />
              <p>Replying to {{ replyTo.direction === 'inbound' ? (activeConversation.contact.name ? activeConversation.contact.name : activeConversation.contact.phone) : 'yourself' }}</p>
            </div>
            <div class="body">
              <MediaMessage
                v-if="isMediaMessage(replyTo)"
                :message="replyTo"
                force-black />
              <LocationMessage
                v-else-if="
                  (replyTo.media_type && replyTo.media_type === 'location') ||
                    (replyTo.type && replyTo.type === 'location')
                "
                :location="replyTo.media_url || replyTo.body"
              />
              <p
                v-else
                :class="{ 'text-arabic': isRightAlignedText(replyTo.body || '') }"
                class="text-message"
              >
                <MessageContent
                  :content="replyTo.body"
                  :detect-urls="true" />
              </p>
            </div>
          </div>
        </div>
        <SBIcon
          :icon="SBIconList.CLOSE_THIN"
          color="#7C8B91"
          :hover-icon-color="SBColors.blackPrimary"
          :size="8"
          :hover-size="14"
          class="ml-2"
          pointer
          @click="cancelReplyTo" />
      </div>
      <!-- <ScrollArea
        v-if="!recordingInProgress"
        ref="inputScrollArea"
        class="input-scroll-area"
        :scroll-offset="13"
        @bottom="scrollToBottom"
        @top="scrollToTop" > -->
      <MessageInputTextarea
        v-if="!recordingInProgress"
        ref="newOutboundMessage"
        v-model="messageContent"
        :prevent-submit="hideSendButton"
        :disabled="disabled"
        @formatting="formatButtonsState"
        @gotFocus="gotFocus"
        @lostFocus="lostFocus"
        @textInserted="scrollToLastPosition"
        @raw-input="watchInput"
        @submit="sendMessage" />
      <!-- </ScrollArea> -->
      <div
        v-if="!recordingInProgress"
        class="tools flex">
        <span
          class="format flex"
          :class="{'greedy justify-end': allActionsToRight}">
          <SBIcon
            v-if="!hideQuickRepliesButton"
            id="quick-replies-btn"
            :active="startQuickReplies"
            :icon="SBIconList.QUICKREPLY"
            :color="SBColors.blackUltralight"
            :hover-color="SBColors.greyChatBubble"
            :hover-icon-color="SBColors.blackPrimary"
            :hover-size="30"
            :size="16"
            @click="startQuickReply" />
          <b-popover
            target="quick-replies-btn"
            triggers="hover"
            placement="top"
            boundary-padding="0"
            custom-class="basic-popover" >
            Quick replies
          </b-popover>
          <SBIcon
            id="bold-btn"
            :active="boldActive"
            :icon="SBIconList.FORMAT_B"
            :color="SBColors.blackUltralight"
            :hover-color="SBColors.greyChatBubble"
            :hover-icon-color="SBColors.blackPrimary"
            :hover-size="30"
            :size="14"
            @click="boldIt" />
          <b-popover
            target="bold-btn"
            triggers="hover"
            placement="top"
            boundary-padding="0"
            custom-class="basic-popover" >
            Bold
          </b-popover>
          <SBIcon
            id="italic-btn"
            :active="italicActive"
            :icon="SBIconList.FORMAT_I"
            :color="SBColors.blackUltralight"
            :hover-color="SBColors.greyChatBubble"
            :hover-icon-color="SBColors.blackPrimary"
            :hover-size="30"
            :size="14"
            @click="italicIt" />
          <b-popover
            target="italic-btn"
            triggers="hover"
            placement="top"
            boundary-padding="0"
            custom-class="basic-popover" >
            Italic
          </b-popover>
          <SBIcon
            id="strike-btn"
            :active="strikeActive"
            :icon="SBIconList.FORMAT_S"
            :color="SBColors.blackUltralight"
            :hover-color="SBColors.greyChatBubble"
            :hover-icon-color="SBColors.blackPrimary"
            :hover-size="30"
            :size="14"
            @click="strikethroughIt" />
          <b-popover
            target="strike-btn"
            triggers="hover"
            placement="top"
            boundary-padding="0"
            custom-class="basic-popover" >
            Strikethrough
          </b-popover>
        </span>
        <span
          class="widgets flex justify-end"
          :class="{greedy: !allActionsToRight}">
          <SBIcon
            :id="`emoji-${componentId}`"
            :icon="SBIconList.EMOJI"
            :color="SBColors.blackUltralight"
            :hover-icon="SBIconList.EMOJI_COLOR"
            :hover-color="SBColors.greyChatBubble"
            :hover-size="30"
            :mask-hover="false"
            :size="16"
            @click="toggleEmoji" />
          <b-popover
            :target="`emoji-${componentId}`"
            triggers="hover"
            placement="top"
            custom-class="basic-popover"
            boundary="viewport"
            boundary-padding="0" >
            Emoji
          </b-popover>
          <SBIcon
            v-if="!hideTemplateButton"
            id="template-message-btn"
            :icon="SBIconList.WHATSAPP_LOGO"
            :color="SBColors.blackUltralight"
            :hover-icon="SBIconList.WHATSAPP_LOGO_COLOR"
            :hover-color="SBColors.greyChatBubble"
            :hover-size="30"
            :mask-hover="false"
            :size="16"
            @click="initiateNotifications" />
          <b-popover
            v-if="!hideTemplateButton"
            target="template-message-btn"
            triggers="hover"
            placement="auto"
            custom-class="basic-popover flex-body" >
            <SBIcon
              class="ml-1 mr-1"
              :icon="SBIconList.WHATSAPP_LOGO_THICK"
              :color="SBColors.blackPrimary"
              :size="14" />
            Message Template
          </b-popover>
          <!-- Hidden for now -->
          <!-- <SBIcon
            v-if="!hideQuickReplyButton"
            id="quick-btn"
            :icon="SBIconList.QUICKREPLY"
            :color="SBColors.blackUltralight"
            :hover-icon="SBIconList.QUICKREPLY_COLOR"
            :hover-color="SBColors.greyChatBubble"
            :hover-size="30"
            :mask-hover="false"
            :size="16" />
          <b-popover
            v-if="!hideQuickReplyButton"
            target="quick-btn"
            triggers="hover"
            placement="top"
            custom-class="basic-popover" >
            Quick reply
          </b-popover> -->
          <!-- Refferences file input from fule-uploiads component -->
          <label
            ref="fileSelectLabel"
            for="file"
            class="m-0" />
          <SBIcon
            v-if="!hideFileButton"
            id="file-btn"
            class=""
            :icon="SBIconList.ATTACH"
            :color="SBColors.blackUltralight"
            :hover-color="SBColors.greyChatBubble"
            :hover-icon-color="SBColors.blackPrimary"
            :hover-size="30"
            :size="16"
            @click="attachFile" />
          <b-popover
            v-if="!hideFileButton"
            target="file-btn"
            triggers="hover"
            placement="top"
            custom-class="basic-popover"
            boundary="viewport"
            boundary-padding="0" >
            Attach file
          </b-popover>
          <!-- Last icon changes depending on the message input content -->
          <SBIcon
            v-if="!blockSend && !hideSendButton && messageContent"
            :icon="SBIconList.SEND"
            :color="SBColors.blackUltralight"
            :hover-color="SBColors.greyChatBubble"
            :hover-icon-color="SBColors.blackPrimary"
            :hover-size="30"
            :mask="false"
            :mask-hover="false"
            :size="16"
            @click="submitMessage" />
          <div
            v-if="blockSend"
            class="flex center-all ml-1"
            style="width: 30px; height: 30px;" >
            <Spinner
              :size="17"
              :thickness="2" />
          </div>
          <SBIcon
            v-show="!blockSend && !hideAudioButton && !messageContent"
            :id="recordAudioId"
            :icon="SBIconList.MICROPHONE"
            :color="SBColors.blackUltralight"
            :hover-color="SBColors.greyChatBubble"
            :hover-icon-color="SBColors.blackPrimary"
            :hover-size="30"
            :size="16"
            @click="startRecording" />
          <b-popover
            :target="recordAudioId"
            triggers="hover"
            placement="top"
            custom-class="basic-popover"
            boundary="viewport"
            boundary-padding="0" >
            Voice message
          </b-popover>
        </span>
      </div>
    </div>
    <QuickReplies
      v-if="startQuickReplies && !recordingInProgress"
      v-click-outside="hideQuickReply"
      :search="searchQuickReply"
      class="quick-reply-position"
      data-outside-click="quick-reply"
      @abort="quitQuickReply"
      @focus="$refs.newOutboundMessage.focus()"
      @replySelected="inputReplyToMessageArea" />
    <picker
      v-show="showEmojiPicker"
      v-click-outside="closeEmojis"
      class="emoji-picker"
      set="emojione"
      title="Pick your emoji..."
      emoji="point_up"
      :native="true"
      @select="emojiSelected" />
    <dictaphone
      ref="dictaphone"
      @cancel="cancelRecording"
      @start="recordingStarted"
      @stop="handleRecording"
      @error="handleRecordError">
      <!-- TODO move this to component when V3 refactor starts -->
      <template
        slot-scope="{ isRecording, recordingTime, stopRecording, deleteRecording }">
        <div
          v-if="isRecording"
          class="recording-process">
          <div class="record-panel flex center-all">
            <span class="time greedy flex justify-start center-all">
              <SBIcon
                class="ticker"
                :icon="SBIconList.MICROPHONE_ACTIVE"
                :color="SBColors.redPrimary"
                :size="16" />
              <span>{{ recordingTime }}</span>
            </span>
            <span
              class="record-button delete-record"
              @click="deleteRecording">
              <SBIcon
                id="cancel-rec"
                :icon="SBIconList.CLOSE_THIN"
                :color="SBColors.redPrimary"
                :size="12"
                :hover-color="SBColors.greyChatBubble"
                :hover-size="30" />
              <b-popover
                target="cancel-rec"
                triggers="hover"
                placement="top"
                custom-class="basic-popover" >
                Cancel
              </b-popover>
            </span>
            <span
              class="record-button save-record"
              @click="stopRecording">
              <SBIcon
                id="send-rec"
                :icon="SBIconList.SEND"
                :color="SBColors.bluePrimary"
                :size="15"
                :hover-color="SBColors.greyChatBubble"
                :hover-size="30" />
              <b-popover
                target="send-rec"
                triggers="hover"
                placement="top"
                custom-class="basic-popover" >
                Send
              </b-popover>
            </span>
          </div>
        </div>
      </template>
    </dictaphone>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { Picker } from 'emoji-mart-vue';
import { debounce } from 'debounce';

import ScrollArea from '@/components/common/ScrollArea';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import SBColors from '@/helpers/lists/colors';
import MessageInputTextarea from './MessageInputTextarea';
import randomString from '@/helpers/randomString';
import Dictaphone from '@/components/common/recorder/Dictaphone';
import Permissions from '@/mixins/Permissions';
import QuickReplies from '@/components/business/chat/partials/QuickReplies';
import JuneMixin from '@/mixins/June';
import MessageContent from '@/components/common/MessageContent';
import LocationMessage from '@/components/business/chat/partials/LocationMessage';
import MediaMessage from '@/components/business/chat/partials/MediaMessage';
import { isRightAlignedText } from '@/helpers/stringHelpers';
import Spinner from '../../../common/Spinner';

export default {
  name: 'MessageInput',
  components: {
    Dictaphone,
    Picker,
    SBIcon,
    ScrollArea,
    Spinner,
    QuickReplies,
    MessageInputTextarea,
    MessageContent,
    LocationMessage,
    MediaMessage,
  },
  mixins: [
    Permissions,
    JuneMixin,
  ],
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    blockSend: {
      type: Boolean,
      required: false,
      default: false,
    },
    focusShadow: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideQuickRepliesButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideTemplateButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideFileButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideAudioButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideSendButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideQuickReplyButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    /** Moves all buttons (including formatting buttons) to the right of the input box. */
    allActionsToRight: {
      type: Boolean,
      required: false,
      default: false,
    },
    preventStoreChanges: {
      type: Boolean,
      required: false,
      default: false,
    },
    replyTo: {
      type: Object,
      required: false,
      default: null,
    },
    // Used for testing the input component. It will not trigger the send message action. On rewrite this should to send the message should be removed and enabled from the parent component from which the message should be sent because this component coulb be used for different thing then.
    testing: {
      type: Boolean,
      required: false,
      default: false,
    },
    emitAudio: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      boldActive: false,
      inputWraperFocused: false,
      italicActive: false,
      lastScrollPos: 0,
      messageContent: '',
      recordingInProgress: false,
      showEmojiPicker: false,
      strikeActive: false,
      preventEmojiClose: false,
      startQuickReplies: false,
      searchQuickReply: '',
      rawInput: '',
      clickOutsideTargets: {},
      preventOutsideClick: false,
      componentId: null,
      SBIconList,
      SBColors,
    };
  },
  computed: {
    ...mapGetters({
      activeConversation: 'chat/activeConversation',
      currentOrganisation: 'organisation/currentOrganisation',
      me: 'organisation/me',
      inputMessageText: 'chat/inputMessageText',
      inputBackup: 'chat/inputBackup',
    }),
    conversationId() {
      return this.$route.params.conversationId;
    },
    /** If multiple audio record icons are present via this component they will all have the same id and the popover will be shown n timeš on each icon causing the background to be darker since it overlaps. */
    recordAudioId() {
      return `audio-message-btn-${randomString()}`;
    },
  },
  watch: {
    messageContent() {
      this.$emit('input-change', this.messageContent);

      // save to state so media modal can use it if needed
      if (!this.preventStoreChanges) {
        this.updateInputMessage(this.messageContent);
      }

      // store input text if any
      if (this.messageContent) {
        this.backupOutboundMessage({
          oldConversationId: this.conversationId,
          messageContent: this.messageContent,
        });
      } else {
        this.clearOutboundMessage(this.conversationId);
      }
    },
    conversationId(newConversationId, oldConversationId) {
      this.resetConversation(newConversationId, oldConversationId);
    },
    replyTo() {
      this.$refs.newOutboundMessage.focus();
    },
  },
  mounted() {
    this.componentId = randomString();
    this.$root.$on('bv::modal::show', () => {
      this.preventOutsideClick = true;
    });
    this.$root.$on('bv::modal::hidden', () => {
      this.preventOutsideClick = false;
    });
  },
  methods: {
    ...mapActions({
      sendMessageAPI: 'chat/sendMessage',
      // sendMedia: 'chat/sendMedia',
      sendMedia: 'chat/sendMediaV2',
      reassignConversationOrRevert: 'chat/reassignConversationOrRevert',
      updateInputMessage: 'chat/updateInputMessage',
      backupOutboundMessage: 'chat/backupOutboundMessage',
      clearOutboundMessage: 'chat/clearOutboundMessage',
    }),
    isRightAlignedText,
    /**
     * For this functionality to work please add these two components where you nned the file modal to appear:
     * <DropHere />
     * <PasteImageModal />
     */
    attachFile() {
      if (this.replyTo) {
        this.$eventBus.$emit('pillmessage', 'Media replies are not supported at the moment.');
        return;
      }
      if (this.$refs.fileSelectLabel) {
        this.$refs.fileSelectLabel.click();
      }
    },
    cancelReplyTo() {
      this.$eventBus.$emit('cancel-reply-to');
    },
    isMediaMessage(message) {
      return !!(
        message.media_type &&
        message.media_type !== 'location' &&
        message.media_url
      );
    },
    selectEmoji(emoji) {
      // console.log(emoji);
    },
    /**
     * Initiates bold formatting in the message input editor.
     */
    boldIt() {
      this.$refs.newOutboundMessage.boldIt();
    },
    cancelRecording() {
      this.recordingInProgress = false;
    },
    resetConversation: debounce(function f(newConversationId, oldConversationId) {
      if (this.$refs.newOutboundMessage) this.$refs.newOutboundMessage.clear();
      // reset text if any is stored for selected conversation
      if (this.inputBackup[newConversationId]) {
        this.setHtml(this.inputBackup[newConversationId]);
      }
    }),
    closeEmojis() {
      if (!this.preventEmojiClose) {
        this.showEmojiPicker = false;
      }
    },
    /**
     * Callback which triggers when emoji is selected.
     *
     * @param emoji Emoji object
     */
    emojiSelected(emoji) {
      this.showEmojiPicker = false;
      this.$refs.newOutboundMessage.addAtLastCaretPosition(emoji.native);
    },
    handleRecording(fileData) {
      this.recordingInProgress = false;
      const blob = fileData.blob;
      blob.lastModifiedDate = new Date();
      blob.lastModified = blob.lastModifiedDate.getTime();
      blob.name = `audio-${randomString()}.wav`;

      const formData = new FormData();
      const tempSid = randomString();

      formData.append('file', blob);
      formData.append('temp_sid', tempSid);

      const outboundMessageData = {
        sid: tempSid,
        body: '',
        media_type: 'audio',
        media_url: fileData.url,
        loaded: false,
        direction: 'outbound',
        status: 'sending',
        timestamp: this.$moment().unix(),
        agent: true,
        sender: this.me.name,
        sender_icon: this.me.platform_id,
      };

      // In emit mode no need to send the media to the server, just emit the media data to the parent component.
      if (this.emitAudio) {
        this.$emit('audio', {
          formData,
          fileData,
        });
        return;
      }

      this.$eventBus.$emit('addoutboundmessage', outboundMessageData);

      if (this.replyTo) {
        formData.append('context_id', this.replyTo.id);
        outboundMessageData.context = this.replyTo;
      }

      this.sendMedia({
        merchant_id: this.activeConversation.business_id,
        conversation_id: this.activeConversation.id,
        data: formData,
      });
    },
    handleRecordError(error) {
      this.microphoneUnavailable();
      this.recordingInProgress = false;
      // this.$refs.audioRecordErrorModal.show(error.name);
    },
    /**
     * Initiates italic formatting in the message input editor.
     */
    italicIt() {
      this.$refs.newOutboundMessage.italicIt();
    },
    gotFocus() {
      this.inputWraperFocused = true;
    },
    /**
     * Flags the formating buttons active state if needed based on the current selection.
     *
     * @param activeFormat Quill format object
     */
    formatButtonsState(activeFormats) {
      this.boldActive = activeFormats.bold;
      this.italicActive = activeFormats.italic;
      this.strikeActive = activeFormats.strike;
    },
    /**
     * Records the scroll position so it can rescroll to the same position if needed.
     * It is needed when inserting text(emoji) into vue editor and setting the selection afterwards to be after the inserted text.
     */
    lostFocus() {
      // this.lastScrollPos = this.$refs.inputScrollArea.getScrollPosition();
      this.inputWraperFocused = false;
    },
    /** Shows the action buttons for recording only when recording starts. */
    recordingStarted() {
      this.recordingInProgress = true;
    },
    resetTextTo(text) {
      this.$refs.newOutboundMessage.resetTextTo(text);
    },
    setHtml(htmlInput) {
      this.$refs.newOutboundMessage.setHtml(htmlInput);
    },
    scrollToBottom() {
    //   this.$refs.inputScrollArea.scrollToBottom();
    },
    /**
     * Scrolls the editor to its last known position.
     */
    scrollToLastPosition() {
    //   this.$refs.inputScrollArea.scrollTo(this.lastScrollPos);
    },
    scrollToTop() {
    //   this.$refs.inputScrollArea.scrollToTop();
    },
    inputReplyToMessageArea(replyMessage) {
      this.quitQuickReply();
      this.startQuickReplies = false;
      this.setHtml(replyMessage);
      this.$refs.newOutboundMessage.focus();
    },
    /**
     * Sends a message to the currently selected conversation.
     *
     * @param whatsAppFormatedMessage WhatsApp formated message ready to be sent
     */
    sendMessage(whatsAppFormatedMessage) {
      // When quickreplies get implemented add this to the if below
      // || this.quickRepliesOpened
      if (!whatsAppFormatedMessage) {
        return;
      }

      // Prevent sending just the "/" because that is a shortcut for quick replies and pressing enter should select something from the list that pops up
      if (this.startQuickReplies) {
        return;
      }

      if (this.testing) {
        if (!this.blockSend) {
          this.$emit('testing', whatsAppFormatedMessage);
          this.setHtml('');
        }
        return;
      }

      const tempSid = randomString();
      const payload = {
        organisationId: this.currentOrganisation.id,
        businessId: this.activeConversation.business_id,
        conversationId: this.activeConversation.id,
        data: {
          temp_sid: tempSid,
          message: whatsAppFormatedMessage,
        },
      };

      if (this.activeConversation.user_id !== this.me.id) {
        // Add assign if needed
        const payload = {
          outboundData: {
            organisationId: this.currentOrganisation.id,
            businessId: this.activeConversation.business_id,
            conversationId: this.activeConversation.id,
            userId: this.me.id,
            revertUserId: this.activeConversation.user_id,
            timestamp: this.$moment().unix(),
            action: 'assignment',
            direction: 'activity',
            from_user_id: this.me.id,
            temp_sid: randomString(),
            to_user_id: this.me.id,
            assignment_seen: true,
            seen: true,
          },
          conversation_uid: this.activeConversation.id,
          conversationId: this.activeConversation.id,
          justLocally: true,
        };
        this.reassignConversationOrRevert(payload);
      }

      const outboundMessageData = {
        sid: tempSid,
        body: whatsAppFormatedMessage,
        media_type: null,
        media_url: null,
        loaded: true,
        direction: 'outbound',
        status: 'sending',
        timestamp: this.$moment().unix(),
        agent: true,
        sender: this.me.name,
        sender_icon: this.me.platform_id,
      };
      payload.outboundData = outboundMessageData;
      if (this.replyTo) {
        payload.data.context_id = this.replyTo.id;
        outboundMessageData.context = this.replyTo;
      }
      this.$eventBus.$emit('addoutboundmessage', outboundMessageData);
      this.$refs.newOutboundMessage.clear();
      this.sendMessageAPI(payload);
      this.clearOutboundMessage(this.activeConversation.id);
      this.setHtml('');
      this.juneTrack('Send message');
    },
    startRecording() {
      if (this.replyTo) {
        this.$eventBus.$emit('pillmessage', 'Voice replies are not supported at the moment.');
        return;
      }

      this.checkMicrophonePermissions();
      this.$refs.dictaphone.startRecording();
    },
    initiateNotifications() {
      if (this.replyTo) {
        this.$eventBus.$emit('pillmessage', 'WhatsApp Message Templates can’t be sent as a reply.');
        return;
      }
      this.$emit('notification-btn-pressed');
    },
    /**
     * Calls submit message on the MessageInputTextarea component refference which will format the message in the correct whatsapp format and initiate submit event on the MessageInputTextarea component.
     */
    submitMessage() {
      this.$refs.newOutboundMessage.submitMessage();
    },
    /**
     * Initiates strikethrough formatting in the message input editor.
     */
    strikethroughIt() {
      this.$refs.newOutboundMessage.strikethroughIt();
    },
    toggleEmoji() {
      this.showEmojiPicker = !this.showEmojiPicker;
      this.preventEmojiClose = true;
      setTimeout(() => { this.preventEmojiClose = false; }, 100);
    },
    watchInput(value) {
      this.rawInput = value.replace(/\n/, '');
      value = value.replace(/\n/, '');
      // const match = value.match(/^\/((\w+\s*)+)/, '');
      const match = value.match(/^\/(.*)/, '');
      if (value === '/' || match) {
        this.startQuickReplies = true;
        this.searchQuickReply = match ? match[1] : '';
      } else {
        this.startQuickReplies = false;
      }
    },
    startQuickReply() {
      if (this.startQuickReplies) {
        this.quitQuickReply();
      } else {
        this.$refs.newOutboundMessage.resetTextTo('/');
        this.$refs.newOutboundMessage.focus();
      }
    },
    quitQuickReply() {
      this.$refs.newOutboundMessage.clear();
      this.searchQuickReply = '';
    },
    hideQuickReply(e, el) {
      if (this.preventOutsideClick) {
        return;
      }

      this.$set(this.clickOutsideTargets, el.dataset.outsideClick, true);

      if (this.clickOutsideTargets['input-wrapper'] && this.clickOutsideTargets['quick-reply']) {
        this.quitQuickReply();
      }

      setTimeout(() => {
        this.$set(this.clickOutsideTargets, el.dataset.outsideClick, false);
      }, 10);

      this.clickOutsideTargets = { ...this.clickOutsideTargets };
    },
  },
};
</script>

<style lang="scss" scoped>
.message-input-component {
  position: relative;

  .emoji-picker {
    position: absolute;
    bottom: 43px;
    right: 15px;
    z-index: 1000;

    ::v-deep .emoji {
      border: none !important;
    }
  }

  .message-input-wrapper {
    min-height: 40px;
    border-radius: 5px;
    border: solid 1px $greyBorder;
    overflow: hidden;
    box-shadow: 0 0 3px 0 rgba(48, 54, 70, 0.1);

    &.focus {
      border: solid 1px $blackPrimary;

      &.add-shadow {
        border: solid 1px $greyBorder;
        box-shadow: 0 0 0 3px #bfdeff !important;
      }
    }

    .input-scroll-area {
      max-height: 127px;
      padding: 13px;
    }

    .tools {
      padding: 5px;
      // background-color: $greyUltralight;
      // border-top: solid 1px $greyBorderLight;

      .format {
        .sb-icon {
          cursor: pointer;
          margin-right: 4px;
        }
      }

      .widgets {
        position: relative;

        .sb-icon {
          cursor: pointer;
          margin-left: 4px;
        }

        .emoji-picker {
          position: absolute;
          bottom: 27px;
        }
      }
    }

    &.disabled, &.disabled.focus {
      background-color: $greyUltralight;
      border: solid 1px $greyBorder;
      box-shadow: unset !important;

      .tools {
        background-color: unset;
        border-top-color: $greyUltralight;
      }
    }
  }

  .quick-reply-position {
    position: absolute;
    top: -7px;
    left: 0;
    transform: translateY(-100%);
  }
}
.reply-message {
  padding: 10px;
  border-bottom: solid 1px #E6EBED;
  // box-shadow: 0 0 3px 0 rgba(48, 54, 70, 0.1);

  &.recording-running {
    margin-bottom: 40px;
  }
}

::v-deep .recording-process {
  height: unset;
  top: unset;
  bottom: 5px;
}

::v-deep .reply-message-origin {
  position: relative;

  &::before {
    content: '';
    position: absolute;
    border-left: 2px solid #7dbcfa;
    height: calc(100% - 18px);
    bottom: 0;
  }

  .header {
    font-size: 12px;
    color: $blackUltralight;
    margin: 0 0 6px;
  }

  .body {
    border-radius: 15px;
    border: 2px solid $lightGray;
    overflow: hidden;
    margin-left: 9px;
    width: fit-content;
    white-space: pre-wrap;
    overflow-wrap: anywhere;

    .text-message {
      background-color: $lightGray;
      padding: 5px 10px;
      width: fit-content;
      font-size: 12px;
      line-height: 1.2;

      img {
        width: 14px;
        height: 14px;
        margin: 0 1px;
        vertical-align: -2px !important;
      }
    }

    .media-message {
      background-color: $lightGray;

      .media-image {
        width: 157px;
        height: 157px;

        .SB-lightbox-trigger.show-play-overlay {
          background-size: 50px;
        }
      }

      .caption {
        font-size: 12px;
        max-width: 157px;

        img {
          width: 14px;
          height: 14px;
          margin: 0 1px;
          vertical-align: -2px !important;
        }
      }
    }

    .media-audio {
      .audio-player {
        padding: 4px 10px;
        font-size: 12px;
        background-color: $lightGray;

        .sb-icon span.icon {
          width: 9px;
          height: 9px;
          mask-size: 9px 9px !important;
        }

        .progress-wrapper {
          margin-left: 12px;

          .progress {
            height: 2px;

            &::after {
              width: 6px;
              height: 6px;
              top: 4px;
            }
          }
        }

        .time {
          min-width: 87px;
        }
      }
    }

    .media-file {
      font-size: 12px;

      a, .pdf-download {
        font-size: 12px;
        padding: 6px 12px 6px 7px;
        background-color: $blackUltralight;
        color: $greyChatBubble !important;

        * {
          color: $greyChatBubble !important;
        }

        .sb-icon {
          width: 13px;
          height: 13px;
          .icon.mask {
            width: 13px;
            height: 13px;
            background-size: 13px;
            mask-size: 13px 13px !important;
            background-color: $greyChatBubble !important;
          }
        }
      }

      .media-caption {
        padding: 5px 10px!important;
      }
    }

    .location-message {
      /* 20% smaller than original */
      a {
        height: 120px;
        width: 176px;
      }
    }
  }
}
</style>
